import React, { useRef } from "react";

const loadImageAsBase64 = async (src) => {
  try {
    const response = await fetch(src);
    const blob = await response.blob();
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  } catch (e) {
    console.error('Image load failed:', e);
    return null;
  }
};

const drawVerificationCard = async (el, { filename = 'Verification', hideElementId = null } = {}) => {
  const html2canvas = (await import('html2canvas')).default;

  const hideEl = hideElementId ? document.getElementById(hideElementId) : null;
  if (hideEl) hideEl.style.display = 'none';

  const images = el.querySelectorAll('img');
  const originalSrcs = [];
  await Promise.all(
    Array.from(images).map(async (img, i) => {
      originalSrcs[i] = img.src;
      const base64 = await loadImageAsBase64(img.src);
      if (base64) img.src = base64;
    })
  );

  const canvas = await html2canvas(el, {
    backgroundColor: '#ffffff',
    scale: 2,
    useCORS: true,
    logging: false,
    allowTaint: true,
  });

  Array.from(images).forEach((img, i) => { img.src = originalSrcs[i]; });

  if (hideEl) hideEl.style.display = '';

  const a = document.createElement('a');
  a.download = `${filename}.png`;
  a.href = canvas.toDataURL('image/png');
  a.click();
};

export const useDownloadVerification = ({ filename = 'Verification', hideElementId = null } = {}) => {
  const cardRef = useRef(null);

  const downloadCard = async (e) => {
    if (e) e.stopPropagation();
    const el = cardRef.current;
    if (!el) return;
    try {
      await drawVerificationCard(el, { filename, hideElementId });
    } catch (err) {
      console.error('Download failed:', err);
    }
  };

  return { cardRef, downloadCard };
};

export const DownloadVerificationCard = ({ children, filename = 'Verification', hideElementId = null, className = '' }) => {
  const { cardRef, downloadCard } = useDownloadVerification({ filename, hideElementId });

  return (
    <div className="pos-rel">
      <div ref={cardRef} className={`bg-white ${className}`}>
        {children}
      </div>
      <i
        className="fas fa-download pos-abs cursor-pointer f20 black bg-white br-lite-gray"
        style={{ top: 6, right: 6 }}
        title="Download as PNG"
        onClick={downloadCard}
      />
    </div>
  );
};

export default useDownloadVerification;